import React from 'react';
import { useTranslation } from 'react-i18next';

import Chip from '@material-ui/core/Chip';

import useStatusStyles from '../../hooks/objective/status/useStyle';

import { OBJECTIVE_STATUS_CHIP_LABELS } from '../../utils/const';

const ObjectiveStatusChip = ({ status = OBJECTIVE_STATUS_CHIP_LABELS.UNKNOWN }) => {
  const { t } = useTranslation();

  const classes = useStatusStyles();

  const upperCaseStatus = (status || '').toUpperCase();

  return (
    <Chip
      label={ t(OBJECTIVE_STATUS_CHIP_LABELS[upperCaseStatus]) }
      className={ `${classes[status]} ${classes.chip}` }
    />
  );
};

export default ObjectiveStatusChip;
